var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSettingsSwitches = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5837 17.5H5.83366C4.22283 17.5 2.91699 16.1942 2.91699 14.5833V14.5833C2.91699 12.9725 4.22283 11.6667 5.83366 11.6667H14.5837C16.1945 11.6667 17.5003 12.9725 17.5003 14.5833V14.5833C17.5003 16.1942 16.1945 17.5 14.5837 17.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83366 2.50001L14.5837 2.50001C16.1945 2.50001 17.5003 3.80585 17.5003 5.41668V5.41668C17.5003 7.02751 16.1945 8.33334 14.5837 8.33334H5.83366C4.22283 8.33334 2.91699 7.02751 2.91699 5.41668V5.41668C2.91699 3.80585 4.22283 2.50001 5.83366 2.50001Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83449 5.625C5.94944 5.62454 6.0423 5.53107 6.04199 5.41612C6.04169 5.30117 5.94833 5.20819 5.83338 5.20834C5.71843 5.20849 5.62533 5.30172 5.62533 5.41667C5.62501 5.47217 5.64697 5.52547 5.68629 5.56463C5.72561 5.60379 5.779 5.62554 5.83449 5.625",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5845 14.7917C14.6994 14.7912 14.7923 14.6977 14.792 14.5828C14.7917 14.4678 14.6983 14.3748 14.5834 14.375C14.4684 14.3751 14.3753 14.4684 14.3753 14.5833C14.375 14.6388 14.397 14.6921 14.4363 14.7313C14.4756 14.7704 14.529 14.7922 14.5845 14.7917",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSettingsSwitches);
export default ForwardRef;